var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0028 19.8576C11.5378 19.859 11.0773 19.767 10.6485 19.5872C10.2197 19.4074 9.83135 19.1433 9.50648 18.8106L1.84499 11.016C0.661981 9.80097 0 8.17216 0 6.47637C0 4.78058 0.661981 3.15177 1.84499 1.93678C2.4477 1.32341 3.16656 0.836245 3.95959 0.503713C4.75263 0.171181 5.60395 -5.47813e-05 6.46388 1.31463e-08C7.32382 5.48076e-05 8.17512 0.171399 8.96811 0.504032C9.76111 0.836665 10.4799 1.32392 11.0825 1.93736L12.0034 2.87466L12.9237 1.93795C13.5246 1.32284 14.2428 0.834574 15.0358 0.502092C15.8289 0.16961 16.6805 -0.000329789 17.5404 0.00234076H17.5428C18.4032 0.000100009 19.2553 0.170632 20.0485 0.503826C20.8418 0.83702 21.56 1.32609 22.1607 1.94205C23.3405 3.15646 24.0003 4.783 24 6.47613C23.9997 8.16926 23.3392 9.79555 22.159 11.0095L14.4998 18.81C14.175 19.1428 13.7873 19.407 13.3584 19.587C12.9296 19.7669 12.4691 19.8589 12.004 19.8576H12.0028Z",
    fill: "#FF4141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeRed);
export default __webpack_public_path__ + "static/media/like-red.57a9aa4ad3c27e1fe177880b45e603d0.svg";
export { ForwardRef as ReactComponent };